/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export enum SearchInputPlacement {
  Default = "DEFAULT",
  ApplicationHeader = "APPLICATION_HEADER",
  ScreenHeader = "SCREEN_HEADER",
}
